import React from 'react';
import { Rocket } from 'lucide-react';
export function FooterSection() {
  return <footer className="bg-white border-t border-slate-200 pt-16 pb-8" data-id="element-241">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-242">
        {/* Final CTA */}
        <div className="bg-gradient-to-br from-orange-500 to-amber-500 rounded-[3rem] p-8 md:p-16 text-center mb-16 shadow-xl relative overflow-hidden" data-id="element-243">
          <div className="absolute top-[-20%] left-[-10%] w-[50%] h-[50%] rounded-full bg-white/20 blur-[80px] pointer-events-none" data-id="element-244" />

          <div className="relative z-10" data-id="element-245">
            <h2 className="text-4xl md:text-5xl font-black text-white mb-6 tracking-tight" data-id="element-246">
              Klaar om je kind te zien groeien?
            </h2>
            <p className="text-orange-50 text-lg md:text-xl font-medium mb-10 max-w-2xl mx-auto" data-id="element-247">
              Probeer de demo gratis. Geen account-gedoe, geen creditcard —
              gewoon kijken of het bij jullie past.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-248">
              <a href="#aanmelden" className="bg-white text-orange-600 shadow-[0_4px_0_0_rgb(255,237,213)] hover:bg-orange-50 hover:-translate-y-0.5 active:translate-y-[2px] active:shadow-none rounded-2xl font-bold px-8 py-4 transition-all text-lg" data-id="element-249">
                Meld je aan
              </a>
              <a href="mailto:mick@mvlcreative.com" className="bg-orange-600 text-white shadow-[0_4px_0_0_rgb(154,52,18)] hover:bg-orange-700 hover:-translate-y-0.5 active:translate-y-[2px] active:shadow-none rounded-2xl font-bold px-8 py-4 transition-all text-lg" data-id="element-250">
                Neem contact op
              </a>
            </div>
          </div>
        </div>

        {/* Footer Links & Info */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12" data-id="element-251">
          <div className="md:col-span-2" data-id="element-252">
            <div className="flex items-center gap-2.5 mb-6" data-id="element-253">
              <div className="w-10 h-10 bg-orange-500 rounded-xl flex items-center justify-center text-white font-bold text-lg shadow-sm" data-id="element-254">
                md
              </div>
              <div className="inline-flex items-baseline gap-1.5 select-none text-2xl" data-id="element-255">
                <span className="font-extrabold tracking-tight text-slate-800" data-id="element-256">
                  Meester
                </span>
                <span className="font-extrabold italic tracking-tight text-orange-500" data-id="element-257">
                  djay
                </span>
              </div>
            </div>
            <p className="text-slate-500 font-medium max-w-sm mb-6 leading-relaxed" data-id="element-258">
              Oefenen dat meegroeit met je kind. Voor groep 6, 7 en 8 —
              afgestemd op school, gemaakt voor thuis.
            </p>
            <div className="inline-flex items-center gap-2 bg-orange-50 text-orange-600 px-4 py-2 rounded-xl text-xs font-bold border border-orange-100" data-id="element-259">
              <Rocket className="w-4 h-4" data-id="element-260" />
              Release Candidate (v3.0)
            </div>
          </div>

          <div data-id="element-261">
            <h4 className="font-black text-slate-900 mb-6 text-sm uppercase tracking-wider" data-id="element-262">
              Platform
            </h4>
            <ul className="space-y-4" data-id="element-263">
              <li data-id="element-264">
                <a href="#waarom" className="text-base font-bold text-slate-500 hover:text-orange-500 transition-colors" data-id="element-265">
                  Waarom Meester djay?
                </a>
              </li>
              <li data-id="element-266">
                <a href="#vakken" className="text-base font-bold text-slate-500 hover:text-orange-500 transition-colors" data-id="element-267">
                  Alle Vakken
                </a>
              </li>
              <li data-id="element-268">
                <a href="#hoe-het-werkt" className="text-base font-bold text-slate-500 hover:text-orange-500 transition-colors" data-id="element-269">
                  Hoe het werkt
                </a>
              </li>
              <li data-id="element-270">
                <a href="#faq" className="text-base font-bold text-slate-500 hover:text-orange-500 transition-colors" data-id="element-271">
                  Veelgestelde vragen
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-272">
            <h4 className="font-black text-slate-900 mb-6 text-sm uppercase tracking-wider" data-id="element-273">
              Contact
            </h4>
            <ul className="space-y-4" data-id="element-274">
              <li data-id="element-275">
                <a href="mailto:mick@mvlcreative.com" className="text-base font-bold text-slate-500 hover:text-orange-500 transition-colors" data-id="element-276">
                  mick@mvlcreative.com
                </a>
              </li>
              <li data-id="element-277">
                <a href="https://demo.meesterdjay.nl" target="_blank" rel="noopener noreferrer" className="text-base font-bold text-slate-500 hover:text-orange-500 transition-colors" data-id="element-278">
                  Probeer de demo
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-279">
          <p className="text-slate-500 text-sm font-bold" data-id="element-280">
            © {new Date().getFullYear()} Meester djay — Leren wordt een
            avontuur
          </p>
          <p className="text-slate-500 text-sm font-bold flex items-center gap-2" data-id="element-281">
            Gemaakt met 🧡 in Nederland
          </p>
        </div>
      </div>
    </footer>;
}